import { InfoBanner } from '@ui';
import React from 'react';
import { WarningType } from '../hooks/useResourceWarnings/types';

interface Warning {
  id: string;
  message: string;
  type: WarningType;
}

interface WarningsListProps {
  warnings: Warning[];
}

export const WarningsList: React.FC<WarningsListProps> = ({ warnings }) => (
  <div className="flex flex-col gap-2">
    {warnings.map((w) => (
      <InfoBanner key={w.id} iconType="warning">
        {w.message}
      </InfoBanner>
    ))}
  </div>
);
